<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    스트리밍 상세
                </div>
                <div class="list-content content tab-content">
                    <div
                        class="intro_tab col_2 active"
                    >
                        상세 정보
                    </div>
                    <div
                        class="intro_tab col_2"
                        @click="moveStudent()"
                    >
                        수강학생
                    </div>
                </div>
                <div class="list-content">
                    <streaming-write-component :streamingType="'liveKlassDetail'"
                                               :streamingKey="streamingKey"
                                               :liveKlassKey="liveKlassKey"></streaming-write-component>
                    <div class="pa15 text-center btn_wrap">
                        <el-button style="float: left;" type="danger" @click="remove" v-if="streamingStatus != 3&&streamingStatus != 1">스트리밍 삭제</el-button>
                        <el-button type="save" @click="write">저장</el-button>
                        <el-button type="cancel" @click="$router.push(`/content/liveklass/${liveKlassKey}/streaming`)">목록
                        </el-button>
                        <el-button style="float: right;" type="cancel" @click="statusUpdate" v-if="streamingStatus != 2&&streamingStatus != 3">스트리밍 종료</el-button>
                    </div>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

        </div>
        <live-class-member-list-modal></live-class-member-list-modal>
    </div>
</template>

<script>
import StreamingWriteComponent from "@/components/streaming/StreamingWriteComponent";
import EventBus from "@/utils/event-bus";
import StreamingListComponent from "@/components/streaming/StreamingListComponent";
import LiveClassMemberListModal from "@/components/modal/LiveClassMemberListModal";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: 'LiveKlassStreamingDetail',
    mixins: [alertMixins],
    components: {StreamingWriteComponent, StreamingListComponent, LiveClassMemberListModal},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            liveKlassKey: Number(this.$route.params.idx),
            streamingKey: Number(this.$route.params.s_idx),
            streamingStatus : 1,
        }
    },
    created() {
    },
    mounted() {
        EventBus.$on("setStreamingStatus",this.setStreamingStatus);
    },
    beforeDestroy() {
        EventBus.$off("setStreamingStatus");
    },
    destroyed() {
    },
    computed: {},
    methods: {
        write() {
            EventBus.$emit("writeStreaming", false);
        },
        statusUpdate() {
            this.createConfirm({
                    content: '스트리밍 대해 완료 처리하시겠습니까?<br> 변경후 상태 변경 불가합니다.',
                    confirmButtonText:"종료",
                    confirm: () => {
                        EventBus.$emit("writeStreaming", true);
                    }
                })
        },
        remove() {
            EventBus.$emit("removeStreaming");
        },
        moveStudent() {
            this.$router.push(`/content/liveklass/${this.liveKlassKey}/streaming/${this.streamingKey}/student`);
        },
        setStreamingStatus(data){
            this.streamingStatus = data;
        },
    },
    watch: {
        "$route.path": {
            deep: true,
            handler: function (val, oldVal) {
                if (
                    !util.isEmpty(this.$route.query.tab) &&
                    this.tab != this.$route.query.tab
                ) {
                    this.changeTab(this.$route.query.tab);
                }
            },
        },
    },
}
</script>
